import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder, formatDate } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoQuota extends Component {

  render() {
    const { quota } = this.props;
    const summary = getTitleSummary(quota)
    return (
      <CodeInfoSection
        title={{
          headers: ['Квоты'],
          rows: summary
        }}
        expanded={(quota.length !== 0) ? true : false}
        table={{
          headers: [
            '',
            'Направление',
            'Описание',
            'Страна происхождения',
            'Страна',
            'Объем',
            'Единицы измерения',
            'Дата начала',
            'Дата окончания',
            'Нормативный документ'
          ],
          rows: quota.map(({
            customs_proc = '',
            to_date = null,
            description = '',
            origin_country = '',
            applied_to_country = '',
            amount = '',
            unit = {},
            from_date = null,
            order, order_date, orders_info = null
          }) => ([
            <ToDateNotificator to_date={to_date} />,
            customs_proc,
            description,
            origin_country,
            applied_to_country,
            amount,
            unit.name,
            formatDate(from_date),
            formatDate(to_date),
            formatOrder(order, order_date, orders_info)
          ]))
        }}
      />
    );
  }
}

function getTitleSummary(items) {
  return items.length !== 0 ? [['есть']] : null;
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoQuota.js